import type { Meta, StoryObj } from '@storybook/angular';
import { TrustpilotCarouselWidgetComponent } from '../../../app/content/layout/components/atoms/trustpilot-carousel-widget/trustpilot-carousel-widget.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<TrustpilotCarouselWidgetComponent> = {
  title: 'Atoms/Trustpilot/Carousel Widget',
  component: TrustpilotCarouselWidgetComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<TrustpilotCarouselWidgetComponent>;

export const Default: Story = {};
